import { useEffect } from "react";
import { useToast } from "@chakra-ui/react";
import { supabase } from "../utils/supabaseClient";

export default function NotificationToastListener({ businessId, setBadgeCount }) {
  const toast = useToast();

  useEffect(() => {
    if (!businessId) return;

    const soundMap = {
      refund: "/sounds/errorsound.mp3",
      print_scheduled: "/sounds/notificationding.mp3",
      auto_fill: "/sounds/notificationpingpop.mp3",
      auto_fill_warning: "/sounds/chime-alert.mp3",
      slot_booked: "/sounds/postcode-coupons-mailbox.mp3",
      welcome: "/sounds/message-ping.mp3",
      dispatch_failed: "/sounds/chime-alert.mp3",
      alert: "/sounds/chime-alert.mp3",
      reminder: "/sounds/message-ping.mp3",
      success: "/sounds/correctsuccess.mp3",
    };

    const iconMap = {
      refund: "💸",
      print_scheduled: "📦",
      auto_fill: "📦",
      auto_fill_warning: "⏳",
      slot_booked: "✅",
      welcome: "👋",
      dispatch_failed: "❌",
      alert: "🚨",
      reminder: "🔔",
      success: "✅",
    };

    const statusMap = {
      refund: "error",
      auto_fill_warning: "warning",
      dispatch_failed: "error",
      alert: "warning",
      slot_booked: "success",
      welcome: "info",
      print_scheduled: "info",
      auto_fill: "info",
      reminder: "info",
      success: "success",
    };

    const channel = supabase
      .channel("notifications")
      .on(
        "postgres_changes",
        {
          event: "INSERT",
          schema: "public",
          table: "notifications",
          filter: `business_id=eq.${businessId}`,
        },
        (payload) => {
          const note = payload.new;

          // ✅ Snooze check
          const snoozed = JSON.parse(localStorage.getItem("snoozedToasts") || "{}");
          const expiry = snoozed[note.type];
          if (expiry && Date.now() < expiry) return;

          // ✅ Mobile vibration
          if (typeof window !== "undefined" && "vibrate" in navigator) {
            navigator.vibrate([200]);
          }

          // ✅ Sound cue
          const soundPath = soundMap[note.type] || "/sounds/notificationpingpop.mp3";
          const audio = new Audio(soundPath);
          audio.play().catch(() => {});

          // ✅ Badge counter
          if (setBadgeCount) {
            setBadgeCount((prev) => prev + 1);
          }

          // ✅ Toast history
          const history = JSON.parse(localStorage.getItem("toastHistory") || "[]");
          history.unshift({
            type: note.type,
            postcode: note.postcode,
            message: note.message,
            campaign_id: note.campaign_id,
            timestamp: Date.now(),
          });
          localStorage.setItem("toastHistory", JSON.stringify(history.slice(0, 50)));

          // ✅ Icon + status
          const icon = iconMap[note.type] || "🔔";
          const status = statusMap[note.type] || "info";

          toast({
            title: `${icon} ${note.postcode} — ${note.type}`,
            description: note.message,
            status,
            duration: 6000,
            isClosable: true,
            position: "top-right",
            variant: "solid",
          });
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [businessId, toast, setBadgeCount]);

  return null;
}
